import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Guards platform-operator surfaces - the raw catalog index, the app
 * visualizer and anything else that exposes the platform's own wiring rather
 * than a tenant's own resources.
 *
 * No `RbacPolicy` in `rbac/platform.yaml` grants this action and the IDP
 * projection only ever emits catalog actions, so the single way to be allowed
 * is the `rbac.platformAdmins` bypass in the permission policy
 * (`group:default/backstage-admins`). That keeps "is this person a platform
 * admin" a permission-backend decision instead of a group-membership check
 * duplicated in the frontend.
 */
export const platformAdminViewPermission = createPermission({
  name: 'platform.admin.view.read',
  attributes: { action: 'read' },
});
